<template>
  <button type="button" :style="styleObject">{{ message }}</button>
</template>

<script>
export default {
  props: {
    message: String,
    backgroundColor: String,
    textColor: String,
    borderColor: String,
  },
  data() {
    return {
      styleObject: {
        backgroundColor: this.backgroundColor,
        color: this.textColor,
        borderColor: this.borderColor,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
button {
  min-width: 150px;
  height: 70px;
  font-size: 30px;
  font-weight: 600;
  border-radius: 8px;
  border: 1px solid;
  padding: 0px 10px;
  &:active {
    outline: none;
  }
  &:hover {
    outline: none;
  }
}
</style>
